import { useCallback } from 'react';
import { AutoPricingCompListingRowOffset } from 'src/components/AutoPricing/AutoPricingCompListingRowOffset/AutoPricingCompListingRowOffset';
import { Content } from 'src/contexts/ContentContext';
import { ContentId } from 'src/utils/constants/contentId';
import { SelectedSectionSettingsWithOptionals } from 'src/utils/types/selectedSectionSettingsWithOptionals';

import { useAutoPricingSettings } from '../../useBulkAutoPricingSettings';
import { PricingSetting } from '../PricingSetting';

export const RowCompsForManualSections = () => {
  const { compListingSelectedSectionSettings, onCompListingChange } =
    useAutoPricingSettings();

  const onRowOffsetChange = useCallback(
    (rowOffset: number | undefined) => {
      const updated: SelectedSectionSettingsWithOptionals = {
        ...(compListingSelectedSectionSettings?.value ?? {}),
        sectionIdFilter:
          compListingSelectedSectionSettings?.value?.sectionIdFilter ?? [],
        rowIdFilter: null,
        sectionRowIdFilter: null,
        rowOffset: rowOffset ?? null,
      };
      onCompListingChange({
        compListingSelectedSectionSettingsNew: updated,
      });
    },
    [compListingSelectedSectionSettings?.value, onCompListingChange]
  );

  return (
    <PricingSetting
      header={<Content id={ContentId.RowComps} />}
      detail={
        <div style={{ width: '50%' }}>
          <AutoPricingCompListingRowOffset
            rowOffset={compListingSelectedSectionSettings?.value?.rowOffset}
            onRowOffsetChange={onRowOffsetChange}
          />
        </div>
      }
      hasConflict={false}
    />
  );
};
